import { PartialTheme } from '@fluentui/react/lib/Theme';

const supsiTheme: PartialTheme = {
    palette: {
       themePrimary: '#0D4CF6',
        themeLighterAlt: '#f0f4fe',
        themeLighter: '#d3defd',
        themeLight: '#a6bdfc',
        themeTertiary: '#618af9',
        themeSecondary: '#265ef7',
        themeDarkAlt: '#0842e2',
        themeDark: '#0735b6',
        themeDarker: '#052680',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff'
    }
};

const supsiDarkTheme: PartialTheme = {
    palette: {
        themePrimary: '#0D4CF6',
        themeLighterAlt: '#010614',
        themeLighter: '#02123B',
        themeLight: '#042376',
        themeTertiary: '#073AC5',
        themeSecondary: '#0946EC',
        themeDarkAlt: '#3066F7',
        themeDark: '#5D87F9',
        themeDarker: '#93AFFB',
        neutralLighterAlt: '#2b2928',
        neutralLighter: '#333231',
        neutralLight: '#41403e',
        neutralQuaternaryAlt: '#4a4846',
        neutralQuaternary: '#514f4d',
        neutralTertiaryAlt: '#6f6c6a',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralSecondaryAlt: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#f8f8f8',
        white: '#201f1e'
    }
};

export { supsiTheme, supsiDarkTheme };